/**
 * 图片卡片
 */
import React, { useCallback, useMemo, useEffect } from "react";
import { MessageStatus, SessionType } from "@/types/chat";
import { MessageSendType } from "@/types/chat/enum";
import lodashGet from "lodash/get";
import styles from "./index.module.less";
import Context from "@/components/chat/context";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { isArray } from "lodash";
import AIImageCard from "@/baseComponents/Chat/AIImagePanel/AIImageCard";
import { connect } from "dvajs";

interface IProps {
  message: any;
  sessionType: SessionType;
  sendType: MessageSendType;
  beginSend?: boolean;
  onReady: (params: { beginSend: boolean; messageExtend: any }) => {};
  clsName?: string;
  showFooter?: boolean;
  files: any[];
}

function ImagesCard(props: IProps) {
  const { message, onReady, sendType } = props;
  const { appRuntimeEnv } = React.useContext<GlobalContextConfig>(GlobalContext);
  const {
    fileService: { imAppKey },
    joyspaceHost
  } = appRuntimeEnv;

  const dataInfo = useMemo(() => {
    let files = lodashGet(message, "data.0.files", []);
    files = isArray(files) ? files : [];
    console.log(`tj:>>[ImagesCard]>>>dataInfo>>>`, files);
    return files;
  }, [message]);
  // 发送
  useEffect(() => {
    if (
      (sendType === MessageSendType.OWNER || sendType === MessageSendType.SELF) &&
      message.status === MessageStatus.INIT
    ) {
      onReady({ beginSend: true, messageExtend: {} });
    }
  }, [sendType, message, onReady]);

  return (
    <div className="content">
      <div className={styles["image-card-wrap"]}>
        <div className={styles["text"]}>{message.content}</div>
        <div className={styles["images-wrap"]}>
          {dataInfo?.map((d: any, idx: number) => {
            return (
              <div className={styles["item"]} key={`card-file-${message.id}_${idx}`}>
                <AIImageCard file={d} readonly={true} message={message} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

function mapStateToProps({ chat }: any) {
  return {
    selectedSession: chat.selectedSession,
    currentEmployee: chat.currentEmployee
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(ImagesCard);
